import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import UniversalRecorderButton from './UniversalRecorderButton';
import ZiggeoMediaRecorder from '../ZiggeoVideo/ZiggeoMediaRecorder';
import HippoMediaRecorder from '../HippoVideo/HippoMediaRecorder';
import UniversalUploaderComponent from '../../shared/UniversalUploader/UniversalVideoUploader';

const Recorder = props => {
  const {
    allowDragAndDrop,
    allowScreen,
    allowUpload,
    allowWebcam,
    apiKey,
    webcamPlaybackEnabled,
    multiStreamEnabled,
    saveMedia,
    disabled,
    mediaLocales,
    onRecording,
    onRecordingStopped,
    onUploading,
    provider,
    recordButtonText,
    recordWebcamEvent,
    setUploadStarted,
    setUploadingComplete,
    handleBadUploadType,
    elementId,
    questionId,
    progressId,
    trackEvents,
    events,
    onBrowserRecordingNotSupported: onBrowserRecordingNotSupportedProp,
    currentUserId,
    wide,
    id,
    seismicRecordingEnabled,
    seismicRecordingVideoElementEnabled,
    seismicPracticeRecordingEnabled,
    seismicWebcamUploadEnabled,
    seismicScreenUploadEnabled,
    seismicVideoElementUploadEnabled,
  } = props;

  const [showRecorder, setShowRecorder] = useState(true);
  const [recordingStarted, setRecordingStarted] = useState(false);

  const onBrowserRecordingNotSupported = () => {};

  const seismicRecordingPracticeOrVidoeEl =
    seismicRecordingEnabled ||
    seismicRecordingVideoElementEnabled ||
    seismicPracticeRecordingEnabled;

  const seismicUploadpracticeEnabled =
    seismicWebcamUploadEnabled ||
    seismicScreenUploadEnabled ||
    seismicVideoElementUploadEnabled;

  const newUploadButton = () => {
    const uploadButtonText = t('lessons.editor.embeds.video.upload');
    return (
      <div className="ZiggeoRecorderContainer minh-240 isSeismicRecording">
        <div className="ZiggeoRecorder SeismicRecordingEnabled">
          <label
            htmlFor="upload"
            className={cn({
              'EditorElement-uploadButton--universalVideoRecorder--top--seismicPracticeRecording EditorElement-uploadButton ta-c':
                seismicPracticeRecordingEnabled,
              'EditorElement-uploadButton--universalVideoRecorder--top--seismicRecordingVideoEl EditorElement-uploadButton ta-c':
                seismicRecordingVideoElementEnabled,
              'EditorElement-uploadButton--universalVideoRecorder EditorElement-uploadButton mt-7 ta-c':
                seismicRecordingEnabled,
            })}
          >
            {uploadButtonText}
          </label>
        </div>
      </div>
    );
  };
  const recordingProvider = provider || 'ziggeo';

  if (recordingProvider === 'hippo_video') {
    return (
      <>
        <div
          className={cn('Recorder', {
            'VideoEmbed--disabled': disabled,
            isSeismicRecording: seismicRecordingPracticeOrVidoeEl,
            ispracticeScreenWebcamRecording: seismicPracticeRecordingEnabled,
            'pt-0': !showRecorder,
          })}
        >
          {seismicRecordingPracticeOrVidoeEl && showRecorder && (
            <UniversalRecorderButton
              recordButtonText={recordButtonText}
              setRecordingStarted={setRecordingStarted}
              seismicRecordingVideoElementEnabled={
                seismicRecordingVideoElementEnabled
              }
              seismicPracticeRecordingEnabled={seismicPracticeRecordingEnabled}
              saveMedia={saveMedia}
            />
          )}
        </div>
        {seismicUploadpracticeEnabled ? (
          <div className="EditorElement-uploadButton">
            <UniversalUploaderComponent
              accept=".video/quicktime, video/mp4, video/x-flv, video/*"
              onComplete={saveMedia}
            />
          </div>
        ) : (
          <HippoMediaRecorder
            allowDragAndDrop={
              !seismicRecordingPracticeOrVidoeEl && allowDragAndDrop
            }
            isScreenRecording={
              !seismicRecordingPracticeOrVidoeEl && allowScreen
            }
            allowUpload={allowUpload}
            allowWebcam={!seismicRecordingPracticeOrVidoeEl && allowWebcam}
            apiKey={apiKey}
            webcamPlaybackEnabled={webcamPlaybackEnabled}
            multiStreamEnabled={multiStreamEnabled}
            saveMedia={saveMedia}
            mediaLocales={mediaLocales}
            recordingStarted={recordingStarted}
            onRecording={onRecording}
            onRecordingStopped={onRecordingStopped}
            onUploading={onUploading}
            recordWebcamEvent={recordWebcamEvent}
            setUploadStarted={setUploadStarted}
            disabled={disabled}
            setUploadingComplete={setUploadingComplete}
            handleBadUploadType={handleBadUploadType}
            trackEvents={trackEvents}
            progressId={progressId}
            questionId={questionId}
            elementId={elementId}
            events={events}
            onBrowserRecordingNotSupported={
              onBrowserRecordingNotSupportedProp ||
              onBrowserRecordingNotSupported
            }
            currentUserId={currentUserId}
            wide={wide}
            seismicRecordingEnabled={seismicRecordingEnabled}
            seismicRecordingVideoElementEnabled={
              seismicRecordingVideoElementEnabled
            }
            seismicPracticeRecordingEnabled={seismicPracticeRecordingEnabled}
          />
        )}
      </>
    );
  }
  return (
    <div
      className={cn('Recorder', {
        'VideoEmbed--disabled': disabled,
        isSeismicRecording: seismicRecordingPracticeOrVidoeEl,
        isVideoElement: seismicRecordingVideoElementEnabled,
        isPracticeRecording: seismicPracticeRecordingEnabled,
        'pt-0': !showRecorder,
      })}
    >
      {seismicRecordingPracticeOrVidoeEl && showRecorder && (
        <UniversalRecorderButton
          recordButtonText={recordButtonText}
          setRecordingStarted={setRecordingStarted}
          seismicRecordingVideoElementEnabled={
            seismicRecordingVideoElementEnabled
          }
          seismicPracticeRecordingEnabled={seismicPracticeRecordingEnabled}
          saveMedia={saveMedia}
        />
      )}
      {recordingStarted && newUploadButton()}
      {!recordingStarted && seismicUploadpracticeEnabled ? (
        <div className="ZiggeoRecorderContainer minh-240 ">
          <div className="EditorElement-uploadButton--universalVideoUploader--top--seismicUploadingEnabled EditorElement-uploadButton ta-c">
            <UniversalUploaderComponent
              accept=".video/quicktime, video/mp4, video/x-flv, video/*"
              onComplete={saveMedia}
            />
          </div>
        </div>
      ) : (
        <ZiggeoMediaRecorder
          id={id || ''}
          isScreenRecording={!seismicRecordingPracticeOrVidoeEl && allowScreen}
          allowUpload={allowUpload}
          allowWebcam={allowWebcam}
          apiKey={apiKey}
          webcamPlaybackEnabled={webcamPlaybackEnabled}
          multiStreamEnabled={multiStreamEnabled}
          saveMedia={saveMedia}
          mediaLocales={mediaLocales}
          onRecording={onRecording}
          onUploading={onUploading}
          recordWebcamEvent={recordWebcamEvent}
          setUploadStarted={setUploadStarted}
          setUploadingComplete={setUploadingComplete}
          handleBadUploadType={handleBadUploadType}
          onBrowserRecordingNotSupported={
            onBrowserRecordingNotSupportedProp || onBrowserRecordingNotSupported
          }
          isSeismicRecording={seismicRecordingEnabled}
          setShowRecorder={setShowRecorder}
          seismicRecordingVideoElementEnabled={
            seismicRecordingVideoElementEnabled
          }
          seismicPracticeRecordingEnabled={seismicPracticeRecordingEnabled}
        />
      )}
    </div>
  );
};

Recorder.propTypes = {
  i18n: PropTypes.shape({}),
  saveMedia: PropTypes.func,
  apiKey: PropTypes.string,
  webcamPlaybackEnabled: PropTypes.bool,
  recordWebcamEvent: PropTypes.func,
  setUploadStarted: PropTypes.func,
  handleBadUploadType: PropTypes.func,
  allowScreen: PropTypes.bool,
  allowUpload: PropTypes.bool,
  allowWebcam: PropTypes.bool,
  multiStreamEnabled: PropTypes.bool,
  mediaLocales: PropTypes.arrayOf(
    PropTypes.shape({
      priority: PropTypes.number,
    }),
  ),
  onRecording: PropTypes.func,
  onUploading: PropTypes.func,
  setUploadingComplete: PropTypes.func,
};

export default Recorder;
